import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from 'firebase/auth';
import { motion } from 'framer-motion';
import { useFireAuth } from '../FireAuthContext';
import { doc, getDoc, setDoc, increment, Timestamp } from 'firebase/firestore';
import { db } from '../App';
import './Login.css';

const Login = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();
  const auth = getAuth();
  const { updateUser } = useFireAuth();

  const getNextMembershipNumber = async () => {
    const membershipCounterRef = doc(db, 'counters', 'membershipNumber');
    const membershipCounterDoc = await getDoc(membershipCounterRef);
    if (membershipCounterDoc.exists()) {
      const currentNumber = membershipCounterDoc.data().count;
      await setDoc(membershipCounterRef, { count: increment(1) }, { merge: true });
      return currentNumber + 1;
    } else {
      await setDoc(membershipCounterRef, { count: 1 });
      return 1;
    }
  };

  const handleGoogleSignIn = async () => {
    setIsLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
  
      const userDoc = await getDoc(doc(db, 'users', user.uid));
  
      if (!userDoc.exists()) {
        const membershipNumber = await getNextMembershipNumber();
        await setDoc(doc(db, 'users', user.uid), {
          name: user.displayName || 'New User',
          email: user.email.toLowerCase(),
          createdAt: new Date(),
          money: 25,
          tokens: 0,
          authorized: true,
          bio: '',
          profilePicture: user.photoURL || 'https://t3.ftcdn.net/jpg/08/05/28/22/240_F_805282248_LHUxw7t2pnQ7x8lFEsS2IZgK8IGFXePS.jpg',
          status: "Hey, I'm new!",
          gamesPlayed: 0,
          membershipNumber,
          membershipStatus: 'Bronze',
          lastDailyReward: Timestamp.now(),
          crypto: { hahumCoin: 0 },
          inventory: [],
          stocks: [],
        });
        setSuccess('Account created successfully with Google.');
        
        setTimeout(() => {
          navigate('/portal/profile');
        }, 1500);
      } else if (userDoc.data().authorized === false) {
        await signOut(auth);
        setError("Access denied. You are not authorized to use this application.");
      } else {
        await updateUser();
        navigate('/portal');
      }
    } catch (error) {
      console.error('Error during Google sign in:', error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="login-page"
    >
      <div className="login-container">
        <h1 className="login-title">Hahum</h1>
        <button onClick={handleGoogleSignIn} className="google-login-button" disabled={isLoading}>
          {isLoading ? 'Signing In...' : 'Login with Google'}
        </button>
        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}
      </div>
    </motion.div>
  );
};

export default Login;
